<template>
  <div class="persona-intro-content" id="identidade-verbal-persona-introducao" data-search-anchor>
    <div class="intro-persona-content">
      <h1 class="intro-persona-title">{{ introTitle }}</h1>
      <div class="intro-persona-paragraphs">        
        <p class="intro-persona-paragraph">{{ introParagraph1 }}</p>
        <p class="intro-persona-paragraph">{{ introParagraph2 }}</p>
        <p class="intro-persona-paragraph">{{ introParagraph3 }}</p>
      </div>      
    </div>
  </div>    
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import PersonaPageMixin from '@/mixins/persona-page-mixin'
import { PersonaPageStore } from '@/store/verbal-identity-page/persona-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class PersonaIntroSection extends Mixins(PersonaPageMixin) {
  personaPageStore: PageStoreContract = getModule(PersonaPageStore, this.$store)

   get introTitle(): string {
    return this.getElementTitle(1, 0)
  }

  get introParagraph1(): string {
    return this.getElementText(1, 1)
  }

  get introParagraph2(): string {
    return this.getElementText(1, 2)
  }

  get introParagraph3(): string {
    return this.getElementText(1, 3)
  }
  
  async getPersonaPage(): Promise<void> {
    await this.personaPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.personaPageStore.isLoading) {
      await this.getPersonaPage()
    }
  }
}
</script>

<style lang="scss">
.persona-intro-content {
  display: flex;
  align-items: center;  
  flex-direction: column;
  width: 100%;
}

.intro-persona-content {  
  display: grid;
  grid-template-columns: 50% 50%;
  justify-content: space-between;  
  width: 100%;  
}

.intro-persona-title {  
  font-size: 48px;
  font-weight: 400;
  line-height: 52px;
  letter-spacing: -0.01em;
  text-align: left;
  width: 440px;  
  margin: 0;
}

.intro-persona-paragraphs {
  width: 503px;
  height: 229px; 
}

.intro-identidade-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.intro-persona-paragraph {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  white-space: pre-line
}

.intro-persona-paragraph:first-of-type {
  margin-top: 0;
}


</style>
